import { validatePassword } from "@/lib/passwordValidation";
import { Check, X } from "lucide-react";

interface Props {
  password: string;
}

const strengthLabels = {
  weak: "Fraca",
  medium: "Média",
  strong: "Forte",
} as const;

const strengthColors = {
  weak: "bg-destructive",
  medium: "bg-yellow-500",
  strong: "bg-green-500",
} as const;

export function PasswordStrengthIndicator({ password }: Props) {
  if (!password) return null;

  const { strength, rules } = validatePassword(password);
  const segments = strength === "weak" ? 1 : strength === "medium" ? 2 : 3;

  return (
    <div className="space-y-2 mt-2">
      {/* Strength bar */}
      <div className="flex gap-1">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors ${
              i <= segments ? strengthColors[strength] : "bg-muted"
            }`}
          />
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        Força: <span className="font-medium">{strengthLabels[strength]}</span>
      </p>

      {/* Rules */}
      <ul className="space-y-1">
        {[
          { key: "minLength" as const, label: "Mínimo 8 caracteres" },
          { key: "hasUppercase" as const, label: "Pelo menos 1 letra maiúscula" },
          { key: "hasNumber" as const, label: "Pelo menos 1 número" },
        ].map(({ key, label }) => (
          <li key={key} className="flex items-center gap-1.5 text-xs">
            {rules[key] ? (
              <Check className="w-3 h-3 text-green-500" />
            ) : (
              <X className="w-3 h-3 text-muted-foreground" />
            )}
            <span className={rules[key] ? "text-green-500" : "text-muted-foreground"}>
              {label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
